














































































import { Component, Vue } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import GenericEdit from "@/core/Generics/GenericEdit";
import Faculty from "@/models/faculty.model";

@Component({})
export default class FacultyEdit extends GenericEdit<Faculty> {
  constructor() {
    super();
    this.controller = "Faculty";
    this.model = new Faculty();
  }

  protected customCancel() {
    if (this.modelDoNotChange) {
      this.confirmedCancel();
      return;
    }

    this.$buefy.dialog.confirm({
      title: "Avertencia",
      type: "is-warning",
      size: "is-medium",
      hasIcon: true,
      confirmText: "Salir",
      cancelText: "No",
      message: "¿Seguro que desea salir de la sección?",
      onConfirm: () => this.goBack()
    });
  }

  protected goBack() {
    this.model = this.map<Faculty>(this.modelInit);
    this.$router.push(`/faculties/${this.$route.params.fid}`);
  }

  protected async customValidate() {
    try {
        var result = await this.$validator.validateAll();
        if (result) {
          this.customEdit();
          return;
        }
        throw this.$validator.errors.items.map(e => e.msg);
    } catch (errors) {
        this.operationFailedErrors(errors);
    }
  }

  protected async customEdit() {
        try {
            this.saving = true;
            var result = await this.repository.update(this.id, this.model);
            this.saving = false;
            this.$emit('edit', result);
            this.clean();
            this.operationSuccess();
            if (this.exitOnSave)
              this.goBack();
        } catch (error) {
            var errors: any[] = [];
            if(Object.prototype.toString.call(error.data) === "[object String]"){
                errors.push(error.data);
            } else if (error.data && error.data.length > 0) {
                var errorMessages = error.data as any[];
                errorMessages.forEach(x => errors.push(x.errorMessage));
            }else{
                errors.push(error);
            }
            console.log(errors);
            this.operationFailedErrors(errors);
        } finally {
            this.saving = false;
        }
    }

}
